/**
 * Mode options for the Member Reward List component action button.
 */
export var MemberRewardListActionButtonMode;
(function (MemberRewardListActionButtonMode) {
    /**
     * Displays the button under the reward list.
     */
    MemberRewardListActionButtonMode["Basic"] = "Basic";
    /**
     * Displays the button as an item in the list.
     */
    MemberRewardListActionButtonMode["ListItem"] = "ListItem";
})(MemberRewardListActionButtonMode || (MemberRewardListActionButtonMode = {}));
